import * as i0 from '@angular/core';
import { NgModule, Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { sendEvent } from '@upr-web-primer/app-utils';
import * as i4 from '@upr-web-primer/gds-common-utility';
import * as i1 from '@upr-web-primer/gds-filter-list';
import * as i2 from '@upr-web-primer/gds-modal';
import * as i3 from '@upr-web-primer/gds-route-resolver';
import { get } from 'lodash-es';
class GdsButtonEventsModule {
  static {
    this.ɵfac = function GdsButtonEventsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsButtonEventsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: GdsButtonEventsModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsButtonEventsModule, [{
    type: NgModule,
    args: [{}]
  }], null, null);
})();
class GdsButtonEventsService {
  constructor(document, gdsFilterListService, gdsModalService, routeResolver, utilities) {
    this.document = document;
    this.gdsFilterListService = gdsFilterListService;
    this.gdsModalService = gdsModalService;
    this.routeResolver = routeResolver;
    this.utilities = utilities;
  }
  /**
   * Handles the button click event
   * @param {any} event - buttonClicked event object to handle all gds button click events
   * @param {GdsButtonEventData} eventData - used for any additional data that needs to provided to button click functionality
   * @returns void
   * @memberof GdsLoaderDirective
   * @method buttonClickHandler
   * @public
   **/
  buttonClickHandler(event, eventData = {}) {
    const el = event.target;
    const rawBtnData = this.utilities.getComponentData(el);
    const btnData = get(rawBtnData, 'button', rawBtnData);
    if (!btnData) return;
    const btnType = get(btnData, 'type') || get(event, 'detail.data.background.link.type');
    if (btnType === 'right-arrow' || btnType === 'left-arrow') return;
    const {
      content,
      contentType,
      theme,
      viewContainerRef
    } = eventData;
    const btnHref = get(btnData, 'href');
    const btnTarget = get(btnData, 'target') || get(event, 'detail.data.background.link.target');
    // update filter-list results
    if (btnData?.customEventDetail?.type === 'filterResults') {
      this.gdsFilterListService.updateResults(btnData);
      return;
    }
    // to adjust filter's on the filter-list
    if (['open-filter', 'clear-filter'].includes(btnTarget)) {
      this.gdsFilterListService.accessFilters(btnData);
      return;
    }
    if (btnTarget === 'application') {
      //customEventDetail from tridion component
      const customEventDetailData = get(btnData, 'customEventDetail') || get(content, 'buttons.EmbeddedValues[0].link.EmbeddedValues[0].Component.LinkedComponentValues[0].Fields.customEventDetail.EmbeddedValues') || [];
      const customEventDetailObject = this.utilities.createObjectFromArray(customEventDetailData);
      this.utilities.applicationRequestHandler(customEventDetailObject);
      return;
    }
    // handle modal links
    if (this.utilities.isModal(btnTarget, btnType)) {
      this.gdsModalService.loadModal(btnData, content, this.utilities.getContrast(), event, theme || '', contentType !== 'dynamic', viewContainerRef);
      return;
    }
    // handle global map modal
    if (btnTarget === 'map-modal') {
      sendEvent('OPEN_GDS_INTERACTIVE_MAP_GLOBAL', {
        href: btnHref
      });
      return;
    }
    // handle route links
    if (btnData.card_type === 'full-image-card') {
      this.routeResolver.resolveRoute(get(event, 'detail.data.background.link'));
      return;
    }
    if (btnTarget === 'privacy') {
      this.openPrivacyModal(el);
      return;
    }
    this.routeResolver.resolveRoute(btnData);
  }
  /**
   * Sends click event to NBCU's CMP Modal
   *
   * @param btnEl
   */
  openPrivacyModal(btnEl) {
    const privacyModal = this.document.querySelector('#onetrust-pc-sdk');
    const isModalVisible = privacyModal?.offsetWidth || privacyModal?.offsetHeight || privacyModal?.getClientRects()?.length;
    if (privacyModal && !isModalVisible) {
      const privacyClicker = btnEl?.querySelector('.ot-sdk-show-settings');
      privacyModal && privacyClicker?.click();
    }
  }
  static {
    this.ɵfac = function GdsButtonEventsService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsButtonEventsService)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i1.GdsFilterListService), i0.ɵɵinject(i2.GdsModalService), i0.ɵɵinject(i3.GdsRouteResolverService), i0.ɵɵinject(i4.GdsCommonUtilityService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GdsButtonEventsService,
      factory: GdsButtonEventsService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsButtonEventsService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: Document,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: i1.GdsFilterListService
  }, {
    type: i2.GdsModalService
  }, {
    type: i3.GdsRouteResolverService
  }, {
    type: i4.GdsCommonUtilityService
  }], null);
})();

/*
 * Public API Surface of gds-button-events
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GdsButtonEventsModule, GdsButtonEventsService };
